import { connect } from 'react-redux';
import { setIsNavDrawerOpen } from '../../navigationSlice';
import RouteAccordion from './RouteAccordion';

const mapState = state => ({
  isNavDrawerOpen: state.navigation.isNavDrawerOpen,
});

const mapDispatch = {
  setIsNavDrawerOpen,
};

export default connect(mapState, mapDispatch)(RouteAccordion);
